import { cn } from 'utils/bem';

export const pagination = cn('pagination');
